import { Stack } from '@mui/material';
import AccordionPanel from '../Accordion';
import moment from 'moment-timezone';
import React from 'react'
import countries from '../../../../utils/ListOfCountries';
import { sortBy } from 'lodash';


const createPhoneList = (type, serverNumbers = []) => {
  return serverNumbers.map((number, index) => ({
    id: `multiPhoneNumbers.${type}-${index}`,
    value: number,
    componentType: type,
    required: true,
    disabled: true
  }));
};


const ProfileRightSection = (props) => {
  const { user, handleStagedData, setTrackUnstagedChanges } = props;
  const timeZones = moment.tz.names()
    .filter(tz => tz !== "Asia/Calcutta")
    .map(tz => ({
      value: tz,
      label: `(GMT ${moment.tz(tz).format('Z')}) ${tz}`,
    }));
  // data expected by client
  

  let incomingProfileData = {
    mentor: user && user.mentor ? user.mentor : "",
    aboutMe: user && user.aboutMe ? user.aboutMe : "",
    emailAddress: user && user.emailAddress ? user.emailAddress : "",
    media: user && user.media ? user.media : "",
    multiPhoneNumbers: user && user.multiPhoneNumbers ? user.multiPhoneNumbers : "",
    nationality: user && user.nationality ? user.nationality : "",
    userCompanyName: user && user.userCompanyName ? user.userCompanyName : "",
    address: user && user.address ? user.address : "",
    phoneNumbers: user && user.phoneNumbers ? user.phoneNumbers : "",
    userName: user && user.userName ? user.userName : "",
    address: user && user.address ? user.address : "",
    userTimezone: user && user.userTimezone ? user.userTimezone : "",
    visible: user && user.visible ? user.visible : "",
    searchable: user && user.searchable ? user.searchable : "",
  };

  const satelliteNumbers = incomingProfileData?.multiPhoneNumbers?.satellite || [];
  const landNumbers = incomingProfileData?.multiPhoneNumbers?.land || [];
  const mobileNumbers = incomingProfileData?.multiPhoneNumbers?.mobile || [];

  const updatedSatellite = createPhoneList('satellite', satelliteNumbers);
  const updatedLand = createPhoneList('land', landNumbers);
  const updatedMobile = createPhoneList('mobile', mobileNumbers);

  const getNationalityValue = () => {
    if (incomingProfileData.nationality !== '') {
      let nation = countries.filter((item) => item?.nation === incomingProfileData?.nationality)[0];
      return nation?.code;
    }
  };

  const getCityValue = () => {
    return incomingProfileData.address?.city || '';
  };

  const getIsRequiredAspectInvalidValue = () => {
    return getCityValue() ? false : true;
  };

  const formFields = [
    { id: 'nationality', type: 'select', componentType: 'form', value: getNationalityValue() || '', label: 'Nationality', disabled: true, options: sortBy(countries, 'nation') },
    { id: 'userCompanyName', type: 'text', componentType: 'form', value: incomingProfileData.userCompanyName || '', disabled: true, label: 'Company' },
    { id: 'addressLine1', type: 'text', componentType: 'form', value: incomingProfileData.address?.addressLine1 || '', disabled: true, label: 'Address' },
    { id: 'city', type: 'text', componentType: 'form', value: getCityValue(), disabled: true, label: 'City', required: true, isRequiredAspectInvalid: getIsRequiredAspectInvalidValue() },
    { id: 'state', type: 'text', componentType: 'form', value: incomingProfileData.address?.state || '', disabled: true, label: 'State' },
    { id: 'postCode', type: 'text', componentType: 'form', value: incomingProfileData.address?.postCode || '', disabled: true, label: 'Code (PIN/ZIP)' },
    { id: 'country', type: 'select', componentType: 'form', value: countries.find(c => c.name === incomingProfileData.address?.country)?.code || '', disabled: true, label: 'Country', options: sortBy(countries, 'name') },
    { id: 'userTimezone', type: 'select', componentType: 'form', value: incomingProfileData?.userTimezone || '', disabled: true, label: 'Timezone', options: timeZones },
  ];

  
  return (
    <Stack sx={{ width: '100%', padding: '1rem 1.5rem' }}
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <AccordionPanel
        setTrackUnstagedChanges={setTrackUnstagedChanges}
        handleStagedData={handleStagedData}
        title='Satellite'
        componentType='satellite'
        shudDeleteBtnRender={true}
        shudClearBtnRender={true}
        isAddButtonVisible={true}
        isEditSaveToggleVisible={true}
        initialFields={updatedSatellite}
        setIsSaveDisabled={props.setIsSaveDisabled}
      />
      <AccordionPanel
        setTrackUnstagedChanges={setTrackUnstagedChanges}
        handleStagedData={handleStagedData}
        title='Landline'
        componentType='land'
        shudDeleteBtnRender={true}
        shudClearBtnRender={true}
        isAddButtonVisible={true}
        isEditSaveToggleVisible={true}
        initialFields={updatedLand}
        setIsSaveDisabled={props.setIsSaveDisabled}
      />
      <AccordionPanel
        setTrackUnstagedChanges={setTrackUnstagedChanges}
        handleStagedData={handleStagedData}
        title='Mobile'
        componentType='mobile'
        shudDeleteBtnRender={true}
        shudClearBtnRender={true}
        isAddButtonVisible={true}
        isEditSaveToggleVisible={true}
        initialFields={updatedMobile}
        setIsSaveDisabled={props.setIsSaveDisabled}
      />
      <AccordionPanel
        setTrackUnstagedChanges={setTrackUnstagedChanges}
        handleStagedData={handleStagedData}
        title='Others'
        componentType='form'
        shudDeleteBtnRender={false}
        shudClearBtnRender={true}
        isAddButtonVisible={false}
        isEditSaveToggleVisible={true}
        accordionDetailsPadding={true}
        initialFields={formFields}
        setIsSaveDisabled={props.setIsSaveDisabled}
      />
    </Stack>
  )
}

export default React.memo(ProfileRightSection)